/**
 * User-facing API error strings. Shared by the worker (`jsonError`) and the
 * web fallbacks so a child always sees the same sentence for the same failure
 * (docs/COPY.md §6). Not an i18n catalogue — de-CH only for now.
 */
import { GUARD_MESSAGE_DE } from "./textguard.js";

export const MSG = {
  badRequest: "Das hat nicht geklappt.",
  invalid: "Das können wir so nicht speichern.",
  unauthorized: "Bitte zuerst anmelden.",
  forbidden: "Das darfst du nicht.",
  notFound: "Das haben wir nicht gefunden.",
  handleTaken: "Dieser Name ist schon vergeben. Nimm einen anderen.",
  throttle: "Zu viele Versuche. Warte ein wenig und versuch es nochmals.",
  registerBusy:
    "Gerade melden sich sehr viele an. Versuch es in einer Stunde nochmals – mit einem Klassencode geht es sofort.",
  loginFailed: "Name oder PIN stimmt nicht.",
  weakPin: "Diese PIN ist zu leicht zu raten. Nimm sechs andere Ziffern.",
  /** Same sentence as GUARD_MESSAGE_DE — one voice for rejected free text. */
  guard: GUARD_MESSAGE_DE,
  joinUnknown: "Der Klassencode stimmt nicht.",
  alreadyInClass: "Du bist schon in einer Klasse.",
  noClass: "Dafür brauchst du eine Klasse.",
  /** «Wiederholen»: the screen greys the other language out, so only an old link gets here. */
  mixedLang: "Eine Runde übt eine Sprache.",
  tooManyCurrent: "Höchstens drei Listen sind aktuell. Nimm zuerst bei einer Liste «Aktuell» weg.",
  /** Issue #41: says why, and what to do instead. */
  lastLeader:
    "Du bist die einzige Klassenleitung. Lade zuerst eine zweite Leitung ein, dann kannst du gehen.",
  inviteUnknown: "Der Einladungscode stimmt nicht.",
  recovery: "Der Code stimmt nicht.",
  csrf: "Die Seite war zu lange offen. Bitte neu laden.",
  /** Scan: every failure points to paste, never a dead end (LIST-EDITOR.md §4). */
  scanLimit: "Für heute sind genug Fotos gelesen. Füg die Wörter als Text ein.",
  scanTooBig: "Das Foto ist zu gross. Versuch es nochmals oder füg die Wörter als Text ein.",
  scanFailed: "Auf dem Foto konnten wir keine Wörter lesen. Füg sie als Text ein.",
  scanSlow: "Das Lesen hat zu lange gedauert. Fotografier weniger Zeilen auf einmal.",
} as const;

export type MsgKey = keyof typeof MSG;
